import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  AUTH_ROLE_ID,
  GetRolesResult,
  Role
} from '../models';
import { LocalStorageService } from './local-storage.service';
import { ConfigService } from '../../shared';
import { Rol } from '../enums';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  constructor(protected http: HttpClient, protected localStorageService: LocalStorageService) {
  }


  getRoles(token: string): Observable<{roles: Role[]}> {
    return this.http.post<{ queryResults: GetRolesResult }>(this.getCoreUrl('queryRoles'),
      { tokens: [token] }
    ).pipe(
      map(response => {
        if (response.queryResults.success) {
          return {roles: response.queryResults.roles};
        }
        return null;
      })
    );
  }

  saveRole(role: Role) {
    this.localStorageService.setItem(AUTH_ROLE_ID, role.rolId);
  }

  removeRole() {
    this.localStorageService.removeItem(AUTH_ROLE_ID);
  }

  getCurrentRol(): Rol{
   return this.localStorageService.getItem(AUTH_ROLE_ID) as Rol;
  }

  isUserFree() {
    return this.getCurrentRol() === Rol.USUARIO_LIBRE;
  }

  isProductor() {
    return this.getCurrentRol()  === Rol.PRODUCTOR;
  }

  isAglutinadora() {
    return this.getCurrentRol()  === Rol.AGLUTINADORA;
  }

  isAseguradora() {
    return this.getCurrentRol()  === Rol.ASEGURADORA;
  }

  isAuditor() {
    return this.getCurrentRol()  === Rol.DGRN;
  }

  isAuditorJefe() {
    return this.getCurrentRol()  === Rol.DGRN_JEFE;
  }

  /**
 * Return url from method in core.
 * @param method to url.
 */
  protected getCoreUrl(method: string): string {
    const apiSeguroUrl = ConfigService.config.apiSeguroUrl;
    return `${apiSeguroUrl}/${method}`;
  }

}
